import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fmt } from "../client";
import { PageHeader, Panel, Empty } from "../ui";

const STATS = [
  ["open_reports", "Open reports", "reports"],
  ["open_media_reports", "Flagged media", "reports"],
  ["open_tickets", "Active tickets", "tickets"],
  ["pending_partnerships", "Pending partners", "partnerships"],
];

export default function Overview() {
  const [d, setD] = useState(null);
  useEffect(() => {
    api("/staff/overview").then(setD).catch(() => setD({ recent_audit: [] }));
  }, []);
  return (
    <div>
      <PageHeader kicker="Shift briefing" title="Overview" />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {STATS.map(([k, label, to], i) => (
          <Link key={k} to={`/staff/${to}`} data-testid={`overview-stat-${k}`} style={{ animationDelay: `${i * 60}ms` }}
            className="s-rise group rounded-xl border border-[var(--s-line)] bg-[var(--s-panel)] p-5 transition-colors hover:border-[var(--s-accent)]">
            <p className="s-mono text-[11px] uppercase tracking-wider text-[var(--s-dim)]">{label}</p>
            <p className="s-display mt-3 text-4xl">{d ? d[k] ?? "—" : "…"}</p>
          </Link>
        ))}
      </div>
      <h2 className="s-display mb-4 mt-12 text-lg">Recent staff activity</h2>
      <Panel className="divide-y divide-[var(--s-line)]" data-testid="overview-audit-list">
        {d?.recent_audit?.length ? d.recent_audit.map((a) => (
          <div key={a.id} className="flex flex-wrap items-center justify-between gap-2 px-5 py-3 text-sm">
            <span><span className="s-mono text-[var(--s-accent)]">{a.action_type}</span> <span className="text-[var(--s-dim)]">by {a.staff_email}</span></span>
            <span className="s-mono text-xs text-[var(--s-dim)]">{fmt(a.created_at)}</span>
          </div>
        )) : <Empty>No staff actions recorded yet.</Empty>}
      </Panel>
    </div>
  );
}
